import { Injectable } from '@angular/core';
import {
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  Router,
  UrlTree,
} from '@angular/router';
import { Observable, AsyncSubject } from 'rxjs';
import { first } from 'rxjs/operators';
import { UserService } from '../services/user.service';

@Injectable({
  providedIn: 'root',
})
export class GuestGuard implements CanActivate {
  constructor(private _userService: UserService, private _router: Router) {}
  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ):
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {
    const canActivateSubject = new AsyncSubject<boolean | UrlTree>();
    this._userService.currentUserStream.pipe(first()).subscribe((u) => {
      if (!u) {
        canActivateSubject.next(true);
        canActivateSubject.complete();
      } else {
        const destination = u.is_artist
          ? (u.tos_status === 'Accepted' ? '/composer/my-tracks' : '/composer/term-condition')
          : (u.is_superuser ? '/dashboard' : '/');
        canActivateSubject.next(this._router.createUrlTree([destination]));
        canActivateSubject.complete();
      }
    });
    return canActivateSubject.asObservable();
  }
}
